import { CartItemTypes } from '../enums/CartItemTypes';
import { ICartItem } from '../interfaces/ICartItem';
import { IGroupedShow } from '../interfaces/IGroupedShow';

export function groupCartTicketsByShow(tickets: ICartItem[]): IGroupedShow[] {
  const groupedShows: IGroupedShow[] = [];
  const ticketItems = tickets.filter(x => x.itemType === CartItemTypes.Ticket);

  ticketItems.forEach(x => {
    const fShowId = groupedShows.find(show => show.showId === x.showId);

    if (fShowId) {
      fShowId.tickets.push(x);
    } else {
      groupedShows.push({
        showTitle: x.showTitle,
        showId: x.showId,
        cinemaId: x.cinemaId,
        showBegin: x.showBegin,
        auditoriumName: x.auditoriumName,
        cinemaName: x.cinemaName,
        tickets: [x]
      });
    }
  });

  return groupedShows;
}
